import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  makeStyles,
  Typography
} from "@material-ui/core";
import { Close as CloseIcon, GetApp as GetAppIcon } from "@material-ui/icons";
import { isEmpty } from "lodash";
import React from "react";
import { useIntl } from "react-intl";
import { PdfPreview } from ".";

const useStyles = makeStyles(theme => ({
  title: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(3)
  },
  textFormatted: {
    whiteSpace: "pre-line"
  },
  pdfContainer: {
    overflowX: "hidden"
  }
}));

const PdfDialog = ({ document, title, description, onClose }) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Dialog open onClose={onClose} maxWidth="lg" fullWidth>
      <div className={classes.title}>
        <Typography variant="h5">{title}</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent className={classes.pdfContainer}>
        <PdfPreview documentUrl={document?.url} />
        {!isEmpty(description) && (
          <>
            <br />
            <Typography className={classes.textFormatted}>{description}</Typography>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          startIcon={<GetAppIcon />}
          size="large"
          color="primary"
          download
          href={document?.url}
          target="_blank"
        >
          {intl.formatMessage({
            id: "Pages.EPosterPage.Download",
            defaultMessage: "Download"
          })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PdfDialog;
